import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// components
import RadioWithoutForm from '@atoms/RadioWithoutForm';
import { DivWithShadowAlternate } from '@styled';

// functionality
import useStripeCustomerFromAPI from '@hooks/apiLegacy/useStripeCustomerFromAPI';
import useViewer from '@hooks/useViewer';

const CardContainerStyled = styled.div`
    &:not(:last-child) {
        margin-bottom: 1rem;
    }
`;

const CardsSaved = ({ locale, selectedPayment, onSelect }) => {
    const { viewer } = useViewer();
    const { stripeCustomer } = useStripeCustomerFromAPI({ locale, memberId: viewer?.recordId });

    if (!stripeCustomer || stripeCustomer.cards.length === 0) {
        return null;
    }

    return (
        <DivWithShadowAlternate className="p-1.5rem">
            {stripeCustomer.cards.map(card => {
                const id = `card-${card.id}`;
                const checked = selectedPayment === card.id;

                return (
                    <React.Fragment key={card.id}>
                        <CardContainerStyled>
                            <RadioWithoutForm
                                checked={checked}
                                id={id}
                                label={`Saved ${card.type.toUpperCase()} ending in ••••${card.last4} - Exp. ${
                                    card.exp_month
                                }/${card.exp_year}`}
                                type="radio"
                                name="paymentSelection"
                                value={card.id}
                                onChange={() => onSelect(card.id)}
                            />
                        </CardContainerStyled>
                    </React.Fragment>
                );
            })}
        </DivWithShadowAlternate>
    );
};

CardsSaved.propTypes = {
    locale: PropTypes.string,
    selectedPayment: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onSelect: PropTypes.func.isRequired,
};

export default CardsSaved;
